import axiosInstance from "../config/axiosIntance";
import { Device, GetDevicesByCiamIdServiceResultType } from "../types";

type Params = {
  token: string;
  ciamId: string;
  serviceProvider: string;
  username: string;
};

export const getDevicesByCiamIdService = async ({
  token,
  serviceProvider,
  ciamId,
  username
}: Params): Promise<Device[]> => {
  const dataFetched = await axiosInstance.get<GetDevicesByCiamIdServiceResultType>(`/devices/${ciamId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      serviceProvider,
      username
    }
  });

  return dataFetched.data;
};
